<template>
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.00008 2.65C4.22008 2.65 0.330078 6.54 0.330078 11.32C0.330078 16.1 4.22008 20 9.00008 20C13.7801 20 17.6701 16.11 17.6701 11.33C17.6701 6.55 13.7801 2.65 9.00008 2.65ZM9.75008 11C9.75008 11.41 9.41008 11.75 9.00008 11.75C8.59008 11.75 8.25008 11.41 8.25008 11V6C8.25008 5.59 8.59008 5.25 9.00008 5.25C9.41008 5.25 9.75008 5.59 9.75008 6V11Z"
      fill="white" />
    <path
      d="M11.8901 1.45H6.11008C5.71008 1.45 5.39008 1.13 5.39008 0.73C5.39008 0.33 5.71008 0 6.11008 0H11.8901C12.2901 0 12.6101 0.32 12.6101 0.72C12.6101 1.12 12.2901 1.45 11.8901 1.45Z"
      fill="white" />
  </svg>
</template>